'use client';

import { useEffect } from 'react';
import { useScrollDirection } from '@/src/hooks';

interface SimpleHeaderScrollVisibilityProps {
    targetSelector: string;
    visibleClass: string;
    hiddenClass: string;
}

export default function SimpleHeaderScrollVisibility({
    targetSelector,
    visibleClass,
    hiddenClass,
}: SimpleHeaderScrollVisibilityProps) {
    const { scrollDir, onPageTop } = useScrollDirection(0, -100, 100);
    const isVisible = scrollDir === 'up' || onPageTop;

    useEffect(() => {
        const header = document.querySelector(targetSelector) as HTMLElement;
        if (header) {
            if (isVisible) {
                header.classList.add(visibleClass);
                header.classList.remove(hiddenClass);
            } else {
                header.classList.add(hiddenClass);
                header.classList.remove(visibleClass);
            }
        }
    }, [isVisible, targetSelector, visibleClass, hiddenClass]);

    return null;
}
